import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Storytelling() {
  const videos = [
    {
      id: 1,
      title: 'The Brave Little Tortoise',
      description: 'A heartwarming tale about courage and determination',
      thumbnail: 'https://public.readdy.ai/ai/img_res/f33d6b41b4944dc7ea014a69ca232776.jpg',
    },
    {
      id: 2,
      title: 'The Magic Paintbrush',
      description: 'An enchanting story about creativity and kindness',
      thumbnail: 'https://readdy.ai/api/search-image?query=magical%20paintbrush%20with%20sparkles%20and%20colorful%20paint%20splashes%20children%20book%20illustration%20whimsical%20art%20style%20enchanting%20scene%20vibrant%20colors%20storytelling%20visual%20clean%20simple%20background&width=800&height=600&seq=story-thumb-2&orientation=landscape',
    },
    {
      id: 3,
      title: 'The Singing Bird',
      description: 'A beautiful tale about finding your voice',
      thumbnail: 'https://readdy.ai/api/search-image?query=colorful%20singing%20bird%20on%20tree%20branch%20in%20beautiful%20nature%20setting%20children%20book%20illustration%20style%20joyful%20scene%20warm%20colors%20musical%20theme%20storytelling%20visual%20clean%20simple%20background&width=800&height=600&seq=story-thumb-3&orientation=landscape',
    },
    {
      id: 4,
      title: 'The Friendly Moon',
      description: 'A soothing bedtime story about friendship',
      thumbnail: 'https://readdy.ai/api/search-image?query=smiling%20moon%20in%20starry%20night%20sky%20with%20clouds%20children%20book%20illustration%20peaceful%20bedtime%20scene%20soft%20colors%20dreamy%20atmosphere%20storytelling%20visual%20clean%20simple%20background&width=800&height=600&seq=story-thumb-4&orientation=landscape',
    },
    {
      id: 5,
      title: 'The Clever Rabbit',
      description: 'An exciting adventure about wit and wisdom',
      thumbnail: 'https://readdy.ai/api/search-image?query=smart%20cute%20rabbit%20character%20in%20forest%20setting%20children%20book%20illustration%20style%20adventurous%20scene%20vibrant%20colors%20playful%20atmosphere%20storytelling%20visual%20clean%20simple%20background&width=800&height=600&seq=story-thumb-5&orientation=landscape',
    },
    {
      id: 6,
      title: 'The Rainbow Garden',
      description: 'A colorful story about nature and wonder',
      thumbnail: 'https://readdy.ai/api/search-image?query=beautiful%20colorful%20garden%20with%20rainbow%20and%20flowers%20children%20book%20illustration%20style%20magical%20nature%20scene%20vibrant%20colors%20enchanting%20atmosphere%20storytelling%20visual%20clean%20simple%20background&width=800&height=600&seq=story-thumb-6&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-red-500 to-orange-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Artful Tales with Tennyson</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto mb-8">
            Enchanting bedtime stories that spark imagination and inspire young minds
          </p>
          <a 
            href="https://youtube.com/artfultaleswithtennyson" 
            target="_blank" 
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center bg-white hover:bg-gray-100 text-red-600 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
          >
            <i className="ri-youtube-fill text-2xl mr-3"></i>
            Visit YouTube Channel
          </a>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=african%20storyteller%20reading%20book%20to%20children%20warm%20cozy%20setting%20with%20colorful%20illustrations%20engaging%20educational%20scene%20happy%20kids%20listening%20creative%20atmosphere%20inspiring%20moment%20clean%20simple%20background&width=800&height=600&seq=storytelling-scene&orientation=landscape"
                alt="Storytelling with Tennyson"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">The Magic of Storytelling</h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                <strong>Artful Tales with Tennyson</strong> is a unique storytelling experience designed to captivate young minds and create memorable bedtime moments. Each story is carefully crafted to entertain, educate, and inspire children while promoting positive values and creativity.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Gospel Tennyson Jaja brings stories to life through engaging narration, colorful illustrations, and meaningful lessons. Whether it's tales of brave animals, magical adventures, or heartwarming friendships, every story is designed to spark imagination and create lasting memories.
              </p>
              <div className="bg-red-50 rounded-xl p-6 mb-6">
                <h4 className="text-xl font-bold mb-3 text-red-600">What Makes Our Stories Special</h4>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <i className="ri-check-line text-red-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Age-appropriate content for children</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-red-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Positive moral lessons and values</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-red-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Engaging narration and sound effects</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-red-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Beautiful visual storytelling</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-red-500 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">Perfect for bedtime routines</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Gallery */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Featured Stories</h2>
            <p className="text-xl text-gray-600">Explore our collection of enchanting tales</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {videos.map(video => (
              <div key={video.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all group cursor-pointer">
                <div className="relative overflow-hidden">
                  <img 
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-64 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center">
                      <i className="ri-play-fill text-3xl text-white"></i>
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">{video.title}</h3>
                  <p className="text-gray-600">{video.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a 
              href="https://youtube.com/artfultaleswithtennyson" 
              target="_blank" 
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center bg-red-500 hover:bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
            >
              <i className="ri-youtube-fill text-2xl mr-3"></i>
              Watch More on YouTube
            </a>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Why Storytelling Matters</h2>
            <p className="text-xl text-gray-600">The power of stories in child development</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-brain-line text-4xl text-red-500"></i>
              </div>
              <h4 className="text-xl font-bold mb-3">Imagination</h4>
              <p className="text-gray-600">Stories stimulate creativity and help children develop their imagination</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-4xl text-orange-500"></i>
              </div>
              <h4 className="text-xl font-bold mb-3">Language Skills</h4>
              <p className="text-gray-600">Exposure to stories enhances vocabulary and language development</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-4xl text-yellow-500"></i>
              </div>
              <h4 className="text-xl font-bold mb-3">Emotional Growth</h4>
              <p className="text-gray-600">Stories help children understand emotions and develop empathy</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-parent-line text-4xl text-green-500"></i>
              </div>
              <h4 className="text-xl font-bold mb-3">Bonding Time</h4>
              <p className="text-gray-600">Shared storytelling creates special moments between parents and children</p>
            </div>
          </div>
        </div>
      </section>

      {/* YouTube Embed Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">Subscribe to Our Channel</h2>
              <p className="text-xl text-gray-600">Never miss a new story</p>
            </div>

            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <div className="aspect-video bg-gray-200 rounded-xl mb-6 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-youtube-fill text-6xl text-red-500 mb-4"></i>
                  <p className="text-gray-600 text-lg">Visit our YouTube channel to watch all stories</p>
                </div>
              </div>
              <div className="text-center">
                <a 
                  href="https://youtube.com/artfultaleswithtennyson" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="whitespace-nowrap inline-flex items-center bg-red-500 hover:bg-red-600 text-white px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer"
                >
                  <i className="ri-youtube-fill text-2xl mr-3"></i>
                  Subscribe Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-purple-500 to-pink-600">
        <div className="container mx-auto px-6 text-center text-white">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Need Custom Storytelling Content?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            We create custom stories and content for brands, educational institutions, and special projects
          </p>
          <a 
            href="/contact" 
            className="whitespace-nowrap inline-block bg-white hover:bg-gray-100 text-purple-600 px-8 py-4 rounded-full text-lg font-semibold transition-all cursor-pointer shadow-lg"
          >
            Contact Us for Custom Content
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}